module.exports = __webpack_public_path__ + "static/media/Charing Cross Pavillion (the album of Private J W Linley 1923-1938).8f71b2a6.jpg";